import { useTranslation } from 'react-i18next'
import type { OptionSelectProps } from './types'
import { Form } from '../../../components/Form'
import { getVariantFromOptions } from '../../../utilities'

export const OptionSelect: React.FC<OptionSelectProps> = ({
  option,
  index,
  name,
  selectedOptions,
  flattenedVariants,
}) => {
  const { t } = useTranslation()
  return (
    <Form.Select
      className="flex-1"
      key={option.name}
      name={name}
      label={option.label}
      variant="default"
      filled
      options={option.values.map((option) => {
        const newOptions = [...selectedOptions]
        newOptions[index] = option
        const variant = getVariantFromOptions(newOptions, flattenedVariants)

        return {
          value: option,
          label: variant?.availableForSale
            ? option
            : `${option} (${t('product.out_of_stock')})`,
        }
      })}
    />
  )
}
